module.exports = __webpack_public_path__ + "static/011-688d85eab7f9f98afcbb72bf39f54fcf.jpg";